import type React from 'react'
import { useState } from 'react'

import { revertBooleanApiValue } from 'commons/utils/boolean'
import { Alert, Button, Checkbox, Typography } from 'components'
import { URL_CONST } from 'constants/urls'
import ReactCodeInput from 'react-code-input'
import { useNavigate } from 'react-router-dom'
import { clearState, handleConfirmAuth, resendAuthCode } from 'store/AuthContext/authSlice'
import { setLoginValidation } from 'store/StructuralContext/structuralSlice'
import { useDispatch, useSelector } from 'store/store'

import * as S from './styles'

const ValidateLogin: React.FC = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [code, setCode] = useState<string>('')
  const [checkedPersist, setCheckedPersist] = useState<boolean>(true)
  const [showInvalidCodeError, setShowInvalidCodeError] = useState<boolean>(false)
  const isButtonDisabled = code === '' || code.length < 6

  const { authData, email, isLoading } = useSelector((state) => state.auth)

  const handleInputChange = (value: string) => {
    setShowInvalidCodeError(false)
    setCode(value)
  }

  const handleResendCode = async () => {
    dispatch(resendAuthCode({ ...authData, fl_renv_cod: revertBooleanApiValue(true) }))
  }

  const handleReturn = () => {
    dispatch(setLoginValidation(false))
    dispatch(clearState())
  }

  const handleValidateCode = async (event: React.FormEvent) => {
    event.preventDefault()
    dispatch(
      handleConfirmAuth(
        {
          ...authData,
          ds_cod_senh: code,
          fl_extn_temp_auth: revertBooleanApiValue(checkedPersist),
        },
        () => navigate(URL_CONST.ROOT),
        () => setShowInvalidCodeError(true),
      ),
    )
  }

  return (
    <form autoComplete="true" onSubmit={handleValidateCode}>
      <S.FieldsWrapper>
        <Typography className="title" design="hav-h5-text">
          Verificação
        </Typography>

        <Typography className="description">
          Insira o código <br />
          que foi enviado para o e-mail:
          <br />
          <strong>{email.toLocaleLowerCase()}</strong>
          <br />
          nos campos abaixo.
        </Typography>
        {showInvalidCodeError && (
          <S.ErrorWrapper>
            <Alert
              fullWidth
              kind="error"
              message="Verifique o código digitado e tente novamente."
              title="Código incorreto."
            />
          </S.ErrorWrapper>
        )}
        <ReactCodeInput
          fields={6}
          forceUppercase
          inputMode="latin"
          inputStyle={{
            border: '1px solid #BCBCBC',
            borderRadius: '5px',
            height: '40px',
            marginRight: '10px',
            textAlign: 'center',
            width: '40px',
          }}
          inputStyleInvalid={{
            border: '1px solid #FF0000',
            borderRadius: '5px',
            height: '40px',
            margin: '2.5px',
            textAlign: 'center',
            width: '40px',
          }}
          isValid={!showInvalidCodeError}
          name="code"
          onChange={handleInputChange}
          placeholder="-"
          type="text"
        />
      </S.FieldsWrapper>
      <Checkbox
        checked={checkedPersist}
        label="Manter verificação por 1 semana"
        onChange={() => setCheckedPersist((prev) => !prev)}
        size="small"
      />
      <S.ButtonWrapper>
        <Button
          content="Confirmar"
          disabled={isButtonDisabled}
          fullWidth
          loading={isLoading}
          type="submit"
        />
        <Button active color="secondary" content="Voltar" fullWidth onClick={handleReturn} />
      </S.ButtonWrapper>
      <S.ResendCode onClick={handleResendCode}>Reenviar código</S.ResendCode>
    </form>
  )
}

export default ValidateLogin
